import { css, styled } from 'styled-components';

import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import { colors } from '#/theme/theme';

const sharedItemCss = css`
  display: inline-flex;
  position: relative;
  font-size: 16px;
  font-weight: normal;
  color: ${colors.lightContentGrey};
`;

export const PageFooterLocaleLinksLink = styled(StyledNativeLinkWithRef)`
  ${sharedItemCss};
`;

export const PageFooterLocaleLinksDisabledText = styled.div`
  opacity: 0.5;
  cursor: auto;
  ${sharedItemCss};
`;
